import { format } from 'date-fns';
import { enUS, de, it, fr, es, ja, ko, zhTW } from 'date-fns/locale';
var locales = {
    ja: ja,
    en: enUS,
    de: de,
    es: es,
    ko: ko,
    'zh-TW': zhTW,
    it: it,
    fr: fr,
};
export function fDate(date, newFormat, language) {
    var fm = newFormat || 'PP';
    var lang = language || 'en';
    return date ? format(new Date(date), fm, { locale: locales[lang] }) : '';
}
